import React from 'react';
import Layout from '../components/layout/Layout';

const CookiesPage = () => {
  return (
    <Layout>
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Cookie Policy</h1>
          <p className="text-gray-300">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. What Are Cookies?</h2>
          <p className="text-gray-600 mb-6">
            Cookies are small text files stored on your device when you visit our website. They help us 
            provide a better user experience by remembering your preferences and understanding how you 
            interact with our site.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Types of Cookies We Use</h2>
          
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Essential Cookies</h3>
          <p className="text-gray-600 mb-4">
            Required for basic website functionality. These cannot be disabled as they are necessary 
            for the website to work properly.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-2">Analytics Cookies</h3>
          <p className="text-gray-600 mb-4">
            Help us understand how visitors interact with our website by collecting anonymous information 
            about page visits, time spent, and navigation patterns.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-2">Functional Cookies</h3>
          <p className="text-gray-600 mb-4">
            Remember your preferences and choices to provide enhanced features and personalization.
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-2">Marketing Cookies</h3>
          <p className="text-gray-600 mb-6">
            Used to deliver relevant advertisements and track the effectiveness of our marketing campaigns.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Third-Party Cookies</h2>
          <p className="text-gray-600 mb-6">
            Some cookies are placed by third-party services on our website, including analytics providers 
            and social media platforms. These third parties have their own privacy policies.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Managing Cookies</h2>
          <p className="text-gray-600 mb-4">You can control cookies through your browser settings:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-6">
            <li>Block all cookies</li>
            <li>Delete existing cookies</li>
            <li>Allow cookies from specific sites</li>
            <li>Set preferences for different types of cookies</li>
          </ul>
          <p className="text-gray-600 mb-6">
            Note: Disabling certain cookies may affect website functionality and your user experience.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Cookie Duration</h2>
          <p className="text-gray-600 mb-6">
            Session cookies are temporary and deleted when you close your browser. Persistent cookies 
            remain on your device for a set period or until manually deleted.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Updates to This Policy</h2>
          <p className="text-gray-600 mb-6">
            We may update this Cookie Policy periodically. Changes will be posted on this page with an 
            updated revision date.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Contact Us</h2>
          <p className="text-gray-600 mb-6">
            For questions about our cookie practices:<br />
            Email: info@steamie.net<br />
            Phone: +91 79966 97777
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default CookiesPage;
